import { Global } from "@emotion/react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { globalStyles } from "@/ui/styled";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Global styles={globalStyles} />
    <App />
  </BrowserRouter>
);
